import React from 'react';
import { Stack, Text } from 'library/ui';
import { formatMonthDayYear } from 'shared/Dates';

interface IPayMethod {
    id: number;
    added_at: string;
    is_default: boolean;
    account_type: string;
    last_four: string;
    cardholder_name?: string | null;
    exp_month?: number | null;
    exp_year?: number | null;
    errorMessage: string;
    isLoading: boolean;
}

interface PayMethodProps {
    payMethod: IPayMethod;
}

export default function PayMethod({ payMethod }: PayMethodProps) {
    const expiry =
        payMethod.exp_month && payMethod.exp_year
            ? `Expires ${String(payMethod.exp_month).padStart(2, '0')}/${payMethod.exp_year}`
            : '';
    const detailParts = [payMethod.cardholder_name, expiry].filter(Boolean);

    return (
        <Stack gap="none" align="start">
            <Text component="div">
                {payMethod.account_type} •••• {payMethod.last_four}
            </Text>
            {detailParts.length > 0 && (
                <Text component="div" size="sm" tone="secondary">
                    {detailParts.join(' · ')}
                </Text>
            )}
            <Text component="div" size="sm" tone="secondary">
                Added: {formatMonthDayYear(payMethod.added_at)}
            </Text>
            {payMethod.errorMessage ? (
                <Text component="div" tone="error" weight="bold">
                    {payMethod.errorMessage}
                </Text>
            ) : null}
        </Stack>
    );
}
